import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppRoutes } from "./routes/AppRoutes";

const BACKGROUND_BY_MODE = {
  dark: '#1E1E25',
  light: '#F5F5F5',
};

function AppDashboard() {
  const { mode } = useSelector(state => state.configTab);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--background-color',
      BACKGROUND_BY_MODE[mode] || BACKGROUND_BY_MODE.dark
    );
  }, [mode]);

  return (
    <>
      <AppRoutes></AppRoutes>
    </>
  );
}

export default AppDashboard;
